import { Selector, createSelector } from '@ngxs/store';
import _ from 'lodash';
import { NotificationKey, NotificationNativeState } from './notification-native.state';

export class NotificationNativeStateFunctions {
   @Selector([NotificationNativeState.notificationTemplateKeys])
   private static getNotificationTemplate(notificationTemplateTags: NotificationKey[]) {
      return (tag: string) => {
         return notificationTemplateTags.filter((key) => key.tag === tag) ?? [];
      };
   }

   @Selector([NotificationNativeState.openNotificationKeys])
   private static getOpenNotifications(openNotificationsTags: NotificationKey[]) {
      return (tag: string) => {
         return openNotificationsTags.filter((key) => key.tag === tag) ?? [];
      };
   }

   @Selector([NotificationNativeState.closedNotificationKeys])
   private static getClosedNotifications(closedNotificationTags: NotificationKey[]) {
      return (tag: string) => {
         return closedNotificationTags.filter((key) => key.tag === tag) ?? [];
      };
   }

   @Selector([NotificationNativeState.requestToOpenKeys])
   private static getRequestedToOpen(tags: NotificationKey[]) {
      return (tag: string) => {
         return tags.filter((key) => key.tag === tag) ?? [];
      };
   }

   @Selector([NotificationNativeState.requestToCloseKeys])
   private static getRequestedToClose(tags: NotificationKey[]) {
      return (tag: string) => {
         return tags.filter((key) => key.tag === tag) ?? [];
      };
   }

   @Selector([NotificationNativeStateFunctions.getNotificationTemplate])
   private static isNotificationRequestedToBeCreated(notificationsToCreate: (tag: string) => string[]) {
      return (tag: string) => {
         return !_.isEmpty(notificationsToCreate(tag));
      };
   }

   @Selector([NotificationNativeStateFunctions.getOpenNotifications])
   private static isNotificationOpen(getOpenNotificationsWithTag: (tag: string) => string[]) {
      return (tag: string) => {
         return !_.isEmpty(getOpenNotificationsWithTag(tag));
      };
   }

   @Selector([NotificationNativeStateFunctions.getClosedNotifications])
   private static isNotificationClosed(getClosedNotificationsWithTag: (tag: string) => string[]) {
      return (tag: string) => {
         return !_.isEmpty(getClosedNotificationsWithTag(tag));
      };
   }

   @Selector([NotificationNativeStateFunctions.getRequestedToOpen])
   private static isNotificationRequestedToOpen(tagsToOpen: (tag: string) => string[]) {
      return (tag: string) => {
         return !_.isEmpty(tagsToOpen(tag));
      };
   }

   @Selector([NotificationNativeStateFunctions.getRequestedToClose])
   private static isNotificationRequestedToClose(tagsToClose: (tag: string) => string[]) {
      return (tag: string) => {
         return !_.isEmpty(tagsToClose(tag));
      };
   }

   public static getNotificationTemplateWithTag(tag: string) {
      return createSelector([NotificationNativeStateFunctions.getNotificationTemplate], (getNotificationTemplate: (tag: string) => string[]) => {
         return getNotificationTemplate(tag);
      });
   }

   public static getOpenNotificationsWithTag(tag: string) {
      return createSelector([NotificationNativeStateFunctions.getOpenNotifications], (getOpenNotifications: (tag: string) => string[]) => {
         return getOpenNotifications(tag);
      });
   }

   public static getClosedNotificationsWithTag(tag: string) {
      return createSelector([NotificationNativeStateFunctions.getClosedNotifications], (getClosedNotifications: (tag: string) => string[]) => {
         return getClosedNotifications(tag);
      });
   }

   public static getRequestedToOpenWithTag(tag: string) {
      return createSelector([NotificationNativeStateFunctions.getRequestedToOpen], (getRequestedToOpen: (tag: string) => string[]) => {
         return getRequestedToOpen(tag);
      });
   }

   public static getRequestedToCloseWithTag(tag: string) {
      return createSelector([NotificationNativeStateFunctions.getRequestedToClose], (getRequestedToClose: (tag: string) => string[]) => {
         return getRequestedToClose(tag);
      });
   }

   public static isNotificationWithTagRequestedToBeCreated(tag: string) {
      return createSelector([NotificationNativeStateFunctions.isNotificationRequestedToBeCreated], (isOpen: (tag: string) => boolean) => {
         return isOpen(tag);
      });
   }

   public static isNotificationWithTagOpen(tag: string) {
      return createSelector([NotificationNativeStateFunctions.isNotificationOpen], (isOpen: (tag: string) => boolean) => {
         return isOpen(tag);
      });
   }

   public static isNotificationWithTagClosed(tag: string) {
      return createSelector([NotificationNativeStateFunctions.isNotificationClosed], (isOpen: (tag: string) => boolean) => {
         return isOpen(tag);
      });
   }

   public static isNotificationWithTagRequestedToBeOpened(tag: string) {
      return createSelector([NotificationNativeStateFunctions.isNotificationRequestedToOpen], (isOpen: (tag: string) => boolean) => {
         return isOpen(tag);
      });
   }

   public static isNotificationWithTagRequestedToBeClosed(tag: string) {
      return createSelector([NotificationNativeStateFunctions.isNotificationRequestedToClose], (isOpen: (tag: string) => boolean) => {
         return isOpen(tag);
      });
   }
}
